/**
 * Everyday variadic pipe function (reverse of 'compose')
 * @example pipe(fn1, fn2, fn3)(value) // fn3(fn2(fn1(value)))
 */
export var pipe = function pipe(fn) {
  for (var _len = arguments.length, fns = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    fns[_key - 1] = arguments[_key];
  }
  var piped = fns.reduce(function (prevFn, nextFn) {
    return function (value) {
      return nextFn(prevFn(value));
    };
  }, function (value) {
    return value;
  });
  return function () {
    return piped(fn.apply(void 0, arguments));
  };
};